module.exports = __webpack_public_path__ + "img/sun.bf4ac921.svg";